const trans = require("./i18n.trans");
const da = trans.da;
const en = trans.en;
export const resources = {
    da: {
        translation: da
    },
    en: {
        translation: en
    }
};
